import React from "react";

const SubscriptionCard = ({ pkg, onEdit }) => {
  const { features = [], recommended = false } = pkg;

  return (
    <div
      className={`relative bg-white dark:bg-gray-800 text-gray-900 dark:text-white p-6 rounded-xl shadow-md border ${
        recommended ? "border-purple-600" : "border-gray-200"
      }`}
    >
      {recommended && (
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-purple-600 text-white text-xs font-medium px-3 py-1 rounded-full">
          Recommended
        </div>
      )}

      <h2 className="text-xl font-bold mb-1">{pkg.name}</h2>
      <p className="text-3xl font-extrabold text-[#2563eb] mb-1">${pkg.price}</p>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
        Per month billed monthly
      </p>

      <hr className="border-t border-black dark:border-white my-4" />

      <ul className="text-sm space-y-4">
        {features.map((item) => (
          <li key={item.feature.id}>
            <p
              className={`text-sm font-medium ${
                item.included ? "text-black" : "line-through text-gray-400"
              }`}
            >
              {item.feature.name}
            </p>
            <p className="text-xs text-gray-500 mt-1">{item.feature.description}</p>
          </li>
        ))}
      </ul>

      <button
        onClick={onEdit}
        className="w-full mt-6 bg-[#2563eb] text-white font-semibold py-2 rounded hover:bg-teal-800 transition"
      >
        Edit Plan
      </button>
    </div>
  );
};

export default SubscriptionCard;
